import clsx from 'clsx';
import styles from './Spinner.module.css';

/**
 * Loading spinner component.
 *
 * @param {Object} props
 * @param {'sm' | 'md' | 'lg'} [props.size='md'] - Spinner size
 * @param {string} [props.className] - Additional CSS classes
 *
 * @example
 * <Spinner />
 *
 * @example
 * <Spinner size="lg" />
 */
export default function Spinner({ size = 'md', className }) {
  return (
    <div
      className={clsx(styles.spinner, styles[size], className)}
      role="status"
      aria-label="Loading"
    >
      <span className={styles.srOnly}>Loading...</span>
    </div>
  );
}
